<div class="quill-container bg-full">
  <div #editor [style.height]="height"></div>
  <div #toolbar></div>
</div>
